import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.next.length < 6) { toast.error("New password must be at least 6 characters"); return; }
    if (form.next !== form.confirm) { toast.error("New passwords don't match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success("Password updated");
      setForm({ current: "", next: "", confirm: "" });
      onOpenChange(false);
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not change password");
    } finally { setBusy(false); }
  };

  const cls = "bg-[#0B0F17] border-[#28364F] text-white";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#131B2A] border-[#28364F] text-white max-w-sm" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><KeyRound className="w-4 h-4 text-amber-400" /> Change password</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="space-y-1.5">
            <Label htmlFor="cp-current">Current password</Label>
            <Input id="cp-current" type="password" required autoComplete="current-password" value={form.current}
              onChange={(e) => set("current", e.target.value)} className={cls} data-testid="cp-current-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="cp-next">New password</Label>
            <Input id="cp-next" type="password" required minLength={6} autoComplete="new-password" value={form.next}
              onChange={(e) => set("next", e.target.value)} className={cls} placeholder="6+ characters" data-testid="cp-new-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="cp-confirm">Confirm new password</Label>
            <Input id="cp-confirm" type="password" required autoComplete="new-password" value={form.confirm}
              onChange={(e) => set("confirm", e.target.value)} className={cls} data-testid="cp-confirm-input" />
          </div>
          <Button type="submit" disabled={busy} className="w-full bg-amber-500 hover:bg-amber-400 text-[#0B0F17] font-bold" data-testid="cp-submit-btn">
            {busy ? "Saving..." : "Update password"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
